export const confirmAccountLabel = {
  emailLink: {
    sent: 'Email sent',
    cta: 'Resend',
    error: 'Something went wrong',
  },
};
